import { render, staticRenderFns } from "./categoriesIndex.vue?vue&type=template&id=5a1a283f&scoped=true"
import script from "./categoriesIndex.vue?vue&type=script&lang=js"
export * from "./categoriesIndex.vue?vue&type=script&lang=js"
import style0 from "./categoriesIndex.vue?vue&type=style&index=0&id=5a1a283f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a283f",
  null
  
)

export default component.exports